import { render, staticRenderFns } from "./ModalAlterarTipoUsuario.vue?vue&type=template&id=4cc43346&scoped=true"
import script from "./ModalAlterarTipoUsuario.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarTipoUsuario.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarTipoUsuario.vue?vue&type=style&index=0&id=4cc43346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc43346",
  null
  
)

export default component.exports